import React from 'react';
import './Footer.css'; // Import CSS for Footer

function Footer() {
  return (
    <footer>
      <p>&copy; 2024 National Council of Science Museums</p>
      <p>Contact: info@ncsm.gov.in | Phone: +91-1234567890</p>
    </footer>
  );
}

export default Footer;
